module.exports = __webpack_public_path__ + "img/grievance.753b9b92.gif";